import { LoadableLazy } from '@confluence/loadable';

export const ContentTreeSearchEmptyLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentTreeSearchEmpty" */ '../src/ContentTreeSearchStates.tsx'
			)
		).ContentTreeSearchEmpty,
});

export const ContentTreeSearchErrorLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentTreeSearchError" */ '../src/ContentTreeSearchStates.tsx'
			)
		).ContentTreeSearchError,
});
